import ClearpayConnectMessage from './ClearpayConnectMessage';

export default ClearpayConnectMessage;
